import React from 'react';
import BasicAlert from './BasicAlert';
import MDSpinner from 'react-md-spinner';
import colors from 'constants/colors';
import './styles.scss';

const SpinnerAlert = ({ title, text, shrink = false }) => (
    <BasicAlert
        text={text}
        icon={<MDSpinner size={18} singleColor={colors['$fmTurquoise']} />}
        type={'spinner'}
        title={title}
        shrink={shrink}
    />
);

export default SpinnerAlert;
